module.exports = __webpack_public_path__ + "cloud-data.RLG61v1A.svg";